import { REGEX_PATTERNS } from '../../regex';

const SEGMENT_DELIMITER = REGEX_PATTERNS.stringManipulation.KEBAB_UNDERSCORE_SEGMENT_DELIMITER.regex;

/**
 * @group Functions
 * @summary <blockquote>Converts a string to PascalCase.</blockquote>
 *
 * Splits on kebab-case, underscore, or space delimiters and capitalizes each word.
 *
 * @param str - Input string (e.g. "my-workflow-step", "my_step_name")
 * @returns PascalCase string (e.g. "MyWorkflowStep", "MyStepName")
 * @example
 * ```typescript
 * toPascalCase('my-workflow-step'); // 'MyWorkflowStep'
 * toPascalCase('user_name');        // 'UserName'
 * ```
 */
export function toPascalCase(str: string): string {
  return str
    .split(SEGMENT_DELIMITER)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join('');
}
